import React, { useState } from 'react'
import SmoothCollapse from 'react-smooth-collapse'

interface IReadMore {
	children: any
	text?: { open: string; closed: string }
	color?: string
	collapsedHeight?: string
	expanded?: boolean
}

function ReadMore({
	children,
	text = { open: 'Show less', closed: 'Show more' },
	color,
	collapsedHeight,
	expanded = false,
}: IReadMore) {
	const [isExpanded, setExpanded] = useState(expanded)
	return (
		<>
			<SmoothCollapse
				expanded={isExpanded}
				children={children}
				allowOverflowWhenOpen={true}
				collapsedHeight={collapsedHeight}
			/>
			<div
				onClick={() => setExpanded(!isExpanded)}
				className="d-flex flex-row read-more mb-4 mt-3 pointer">
				<span></span>
				<span
					style={{
						backgroundColor: color,
					}}>
					{isExpanded ? text.open : text.closed}
				</span>
				<span></span>
			</div>
		</>
	)
}

export default ReadMore
